import Tables from 'src/class/Tables';
import UnitFormatter from './UnitFormatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
    },
    {
      prop: 'abbreviation',
      label: i18n.t('common_words.symbol'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'data_formate',
      label: i18n.t('labor.unit_format'),
      sortable: true,
      align: 'center',
      formatter: UnitFormatter,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
}
export default configTable;